export default __webpack_public_path__ + "static/media/maca.db1b1cb6.jpg";